import { BackspaceSharp } from "@material-ui/icons";


export const IconWithText = ({ text }) => (
    <div style={{ display: 'flex', alignItems: 'center' }}>
        <BackspaceSharp style={{ fontSize: '36px', marginRight: '8px' }} /> {/* Renderiza el ícono */}
        <span>{text}</span> {/* Renderiza el texto */}
    </div>
);